import React from "react";
import styled from "styled-components";
import dotGrid from '../Headers/dot-grid.png';
import about from './about.png';
import Testimonials from "../Testimonials";
import CTA from "../CTA";

const Container = styled.div`

`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 100%;
  background-image: url(${dotGrid});
  background-size: 20%;
  background-repeat: no-repeat;

  @media(max-width: 768px) {
    padding-left: 2%;
    padding-right: 2%;
  }

  @media(min-width: 768px) {
    flex-direction: row;
    margin-top: 60px;
    margin-bottom: 60px;
    gap: 2.5%;
  }
`;

const LeftColumn = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 20px;

  @media(min-width: 768px) {
    justify-content: flex-end;
    padding-top: 50px;
    flex: 0.5;
  }
`;

const RightColumn = styled.div`
  display: flex;
  flex: 0.5;
  flex-direction: column;
  justify-content: flex-start;
  padding-top: 20px;
  padding-right: 40px;
`;

const StyledHeader = styled.h2`
  font-size: 22px;

  @media(min-width: 768px) {
    font-size: 50px;
  }
`;

const RegularText = styled.div`
  @media(max-width: 768px) {
    font-size: 12px;
    line-height: 20px;
  }
`;

const ULContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 25px;
  margin-top: -25px;
`;

const ULLeft = styled.div`
  display: flex;
  flex: 0.5;
  flex-direction: column;
`;

const ULRight = styled.div`
  display: flex;
  flex: 0.5;
  flex-direction: column;
`;

const About = () => {
  return (
    <Container>
      <ContentContainer>
      
          <StyledHeader>Terms and Conditions</StyledHeader>
          <RegularText>
            <b>HT 1: Asset Descriptions & Condition</b><br />
            <ul>
              <li>Please read <b>each lot’s full description</b> carefully.</li>
              <li>Please know the <b>accurate location</b> of the asset. </li>
              <li>We strive to provide accurate and thorough details, but <b>all assets are sold AS-IS</b>, with <b>no warranties or guarantees</b> of any kind.</li>
              <li>We <b>strongly recommend on-site inspections</b> before bidding.</li>
            </ul>
            <hr />
            <b>HT 2: Important Notice: Lot Locations</b><br />
            We sell commercial assets <b>nationwide</b>. It is the <b>buyer’s responsibility</b> to verify the <b>exact location</b> of each lot <b>before bidding</b>.<br /><br />
            📍 <b>Unsure about a lot’s location?</b> Contact any of us:
            <ul>
              <li>Eric: 404-547-6823</li>
              <li>Marty: 239-571-2427</li>
              <li>Jason: 678-788-0965</li>
              <li>Jim: 912-695-9406</li>
              <li>Maria: 318-780-2743 (bilingual)</li>
            </ul>
            <hr />
            <b>HT 3: Buyer’s Premium & Payment Terms</b><br />
            <ul>
              <li>A <b>12% buyer’s premium</b> applies to all units if purchasing via Proxibid or EquipmentFacts. This fee is <b>dded to the final bid</b> and should be factored into your bidding strategy. If you bid directly on EquiplincAuctions.com, there is <b>only a 10% buyer’s premium</b>.</li> 
              <li><b>Full payment is due within 48 hours</b> of the auction close.</li>
              <li><b>Financing is not available.</b> Do not attempt to finance after winning a lot.</li>
              <li><b>Failure to pay</b> will result in <b>loss of bidding privilege</b> on Proxibid, EquipmentFacts, Equiplinc and all related bidding platforms.</li>
            </ul>
            <hr />
            <b>HT 4:Pending Seller Confirmations</b><br />
            Some lots may be marked <b>"Pending Seller Confirmation"</b> at the end of the auction.<br />
            This means:
            <ul>
              <li>The asset is <b>not officially sold</b> until the seller confirms acceptance of the high bid.</li>
              <li>Some items have <b>reserve prices</b> and will only be sold if the reserve is met or exceeded.</li>
              <li>This is especially important to EquipmentFacts buyers. </li>
              <li>This applies particularly to assets sold on behalf of <b>banks, credit unions, leasing companies, and other financial institutions</b>.</li>
            </ul>
            <br />
            <b>HT 5:Storage Fees</b><br />
            All purchased assets must be <b>removed within 10 days</b> of the auction date.<br /><br />
            After the 10-day grace period, <b>storage fees will apply</b>:
            <ul>
              <li><b>$25–$75 per day, per unit</b>, depending on the storage facility.</li>
              <li>Buyers must pay all storage fees <b>directly to the facility</b> before assets will be released.</li>
              <li>Buyers are responsible for the arrangements, pick up, and transportation.</li>
            </ul>
            Call us with any questions before bidding.

          </RegularText>

      </ContentContainer>
    </Container>
  )
}

export default About;
